export { TabsModule } from "./TabsModule";
